"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 120 120", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("circle", { fill: fill, cx: "60", cy: "60", r: "60" }),
        react_1.default.createElement("g", { fill: "#ffffff" },
            react_1.default.createElement("path", { d: "M 44.385 97.645 C 39.265 97.645 34.435 94.765 32.175 88.185 L 31.945 96.515 L 15.385 96.515 L 15.385 22.355 L 33.545 22.355 L 33.545 52.595 C 35.425 46.425 40.175 43.135 44.995 43.135 C 56.445 43.135 61.275 56.135 61.275 70.085 C 61.275 84.995 56.605 97.645 44.385 97.645 Z M 37.615 58.865 C 33.175 58.865 33.095 65.755 33.095 70.175 C 33.095 74.285 33.245 82.105 37.465 82.105 C 41.835 82.105 41.985 74.495 41.985 70.175 C 41.985 66.065 41.755 58.865 37.615 58.865 Z" }),
            react_1.default.createElement("path", { d: "M 87.045 96.505 L 86.825 88.895 C 83.585 93.895 79.365 97.635 74.315 97.635 C 67.005 97.635 60.675 93.105 60.675 82.105 C 60.675 67.705 70.995 62.975 80.195 62.975 C 82.5162 63.0284 84.8312 63.2355 87.125 63.595 L 87.125 62.975 C 87.125 56.805 82.125 56.295 77.785 56.295 C 73.3427 56.4456 69.0378 57.8725 65.385 60.405 L 64.935 46.215 C 70.1113 44.327 75.5575 43.2836 81.065 43.125 C 92.475 43.135 104.385 45.805 104.385 64.725 L 104.385 82.525 C 104.385 90.135 104.385 93.115 104.615 96.525 Z M 87.125 73.675 L 85.315 73.675 C 82.315 73.675 77.255 74.605 77.255 79.945 C 77.255 83.545 79.745 84.465 81.475 84.465 C 85.165 84.465 87.125 79.945 87.125 75.415 Z" }))));
};
var Banett = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#0077c0' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill }, rest));
};
exports.default = Banett;
